module.exports = __webpack_public_path__ + "static/media/landing-form-background.c6c73736.png";